import * as React from 'react'
import cx from 'classnames'
import * as styles from './filter.component.styl'
import type { History } from 'history'
import FilterOptions from './components/filter.options'
import { useDispatch, useSelector } from 'react-redux'
import {
  filterActiveSelector,
  getFilterData,
  getFilterOptions,
  getSelectedAccountName
} from './selectors'
import { resetFilter, updateFilter } from '@src/redux/actions/filter.actions'
import type { FilterAccount } from '@src/redux/reducers/filter/default.state'

export type Props = { history: History }

const Filter: React.FC<Props> = (props: Props) => {
  const [showFilterOptions, setFilterOptions] = React.useState(false)
  const dispatch = useDispatch()
  const currentAccountName = useSelector(getSelectedAccountName)
  const accountsList = useSelector(getFilterData)
  const filterOptions = useSelector(getFilterOptions)
  const isActiveFilter = useSelector(filterActiveSelector)

  function onToogle(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    e?.preventDefault()
    e?.stopPropagation()
    setFilterOptions(!showFilterOptions)
  }

  function onClose() {
    setFilterOptions(false)
  }
  function handleReset(callbackFn?: () => void) {
    dispatch(resetFilter(callbackFn))
  }

  function handleUpdate(
    options: { currentAccount: FilterAccount },
    callbackFn: () => void
  ) {
    dispatch(updateFilter(options, callbackFn))
  }

  const { history } = props
  const { currentAccount } = filterOptions
  return (
    <div role={'header_filter_account'} className={styles.container}>
      {currentAccount && (
        <div role={'current_account_name'} className={styles.accountName}>
          {currentAccountName}
        </div>
      )}
      <div
        className={cx(styles.wrapper, {
          [styles.activeMenu]: showFilterOptions,
          [styles.activeFilter]: isActiveFilter
        })}
      >
        <div role={'filter_menu'} className={styles.icon} onClick={onToogle} />
        <span role={'icon'} className={styles.activeIcon} />
        {showFilterOptions ? (
          <FilterOptions
            history={history}
            isActiveFilter={isActiveFilter}
            applyNow={handleUpdate}
            resetAll={handleReset}
            options={filterOptions}
            onClose={onClose}
            accountsList={accountsList}
          />
        ) : null}
      </div>
    </div>
  )
}

export default Filter
